module.exports = __webpack_public_path__ + "img/mile5-m@1.9f563152.webp";